import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=d7ffa3a6"
import script from "./ProductCategory.vue?vue&type=script&lang=ts"
export * from "./ProductCategory.vue?vue&type=script&lang=ts"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=d7ffa3a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QImg,QItem,QItemSection,QItemLabel,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QImg,QItem,QItemSection,QItemLabel})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
